import { render } from "./AddCounselor.vue?vue&type=template&id=0ef83aac&scoped=true"
import script from "./AddCounselor.vue?vue&type=script&lang=js"
export * from "./AddCounselor.vue?vue&type=script&lang=js"

import "./AddCounselor.vue?vue&type=style&index=0&id=0ef83aac&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0ef83aac"

export default script